export default __webpack_public_path__ + "static/media/proud.62a6a2e3.svg";